module.exports = __webpack_public_path__ + "bg.no1.8b4c65d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/bg.no1.jpg
// module id = Xopo
// module chunks = 0